<ion-header>
    <ion-toolbar class="header-color">
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title class="toolbar-title">Forgot Password</ion-title>
    </ion-toolbar>
  </ion-header>

<ion-content>
  <div class="forgot-password">
	<ion-grid>
      <ion-row>
        <ion-col>
        	 <div class="forgot-password-page">
 			      <div class="email-login-section">
 	           <div class="login-source-error" *ngIf="this.authService.forgotPasswordSuccess">
                <span (click)="onCloseSuccessMessage()">
                  <ion-icon name="close"></ion-icon>
                </span>
                <p> We have sent you a password reset link. Please check your inbox. </p>
              </div>
              <div>
                  <div class="divider-alt ui-or">
                      <span class="title-page">Enter your email address and we'll email you a link to reset your password.</span>
                  </div>
              </div>
              <hr class="thick-border" />
              <div class="ion-text-left form-wr">
                  <form [formGroup]="forgotPasswordForm" (ngSubmit)="submitForm()" novalidatenovalidate>
                      <ion-item class="inputStyle">
                          <ion-input
                                  formControlName="email"
                                  type="text"
                                  placeholder="Email Address"
                                  [readonly]="this.authService.forgotPasswordSuccess"
                                  required>
                          </ion-input>
                      </ion-item>
<span *ngIf="this.authService.forgotPasswordError"> <p class="forgot-password-error-message">{{this.authService.forgotPasswordError}}</p></span>
                      <div [hidden]="this.authService.forgotPasswordSuccess">
                  	   <ion-button
                                class="login-button full-width-btn"
                                color="secondary"
                                disabled="false"
                                (click)="onCancelClick()"
                        >
                            CANCEL
                        </ion-button>
                      </div>

                    <ng-container *ngIf="this.forgotPasswordForm.valid">
                        <div [hidden]="this.authService.forgotPasswordSuccess">
                            <ion-button
                                class="login-button full-width-btn"
                                color="tertiary"
                                expand="block"
                                type="submit"
                                disabled="false"
                        >
                           RESET PASSWORD
                        </ion-button>
                        </div>
                        <div *ngIf="this.authService.forgotPasswordSuccess">
                            <ion-button
                                class="login-button full-width-btn"
                                color="tertiary"
                                expand="block"
                                type="submit"
                                disabled="false"
                        >
                           RESEND
                        </ion-button>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!this.forgotPasswordForm.valid">
                        <ion-button
                                class="login-button full-width-btn"
                                color="tertiary"
                                expand="block"
                                type="submit"
                                disabled="true"
                        >
                            RESET PASSWORD
                        </ion-button>
                    </ng-container>
                	</form>
               </div>
           </div>
       </div>
      </ion-col>
    </ion-row>
    </ion-grid>
  </div>
</ion-content>
